import { render, staticRenderFns } from "./Attente.vue?vue&type=template&id=0dfcf698&"
import script from "./Attente.vue?vue&type=script&lang=js&"
export * from "./Attente.vue?vue&type=script&lang=js&"
import style0 from "./Attente.vue?vue&type=style&index=0&id=0dfcf698&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports